// extracted by mini-css-extract-plugin
module.exports = {"planet_decor":"PlanetDecor_planet_decor__h6bke","planet_decor_wrapper":"PlanetDecor_planet_decor_wrapper__al_9l"};